import React, { ReactNode, useEffect, useState } from 'react';

import styles from './HandHistory.module.scss';

/** False on a component's first render, true from the next one on. */
export const useHasMounted = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
};

/**
 * An open card's body. It unfolds (`hh-body-open`) only when a card that is
 * already on screen opens. In the shipping client that is always the player's
 * tap on its header; the playground's example selector can open one too. A
 * card that appears already open, such as the live hand arriving expanded or a
 * list rebuilt on a table switch, shows its body at once: nobody asked for that
 * motion, and it would push a reader scrolled below the card after the scroll
 * hold had measured. Decided when the body mounts, so later renders never
 * start or stop the animation.
 */
export const HandCardBody = ({
  id,
  unfold,
  children
}: {
  id: string;
  unfold: boolean;
  children: ReactNode;
}) => {
  const [animate] = useState(unfold);
  return (
    <div id={id} className={`${styles.handCardBody} ${animate ? styles.handCardBodyUnfold : ''}`}>
      <div className={styles.handCardBodyInner}>{children}</div>
    </div>
  );
};
